import React, { useMemo } from "react";

import { ApolloClient, InMemoryCache, split } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";
import { WebSocketLink } from "@apollo/client/link/ws";
import { getMainDefinition } from "@apollo/client/utilities";

import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
import { useAuth } from "../context/AuthProvider";

// const END_POINT = "localhost:4000/graphql";
const END_POINT = "yrcapi-46879e10c9e4.herokuapp.com/graphql";

const ApolloProviderWrapper = ({ children }) => {
  const { authState } = useAuth();
  const { token } = authState ?? {};

  const client = useMemo(() => {
    const uploadLink = createUploadLink({
      uri: `https://${END_POINT}`,
      headers: {
        authorization: token ? `Bearer ${token}` : "",
      },
    });

    // 🔥 თუ subscription-ებს არ იყენებ, დააყენე false
    const ENABLE_SUBSCRIPTIONS = true;

    if (!ENABLE_SUBSCRIPTIONS) {
      return new ApolloClient({
        link: uploadLink,
        cache: new InMemoryCache(),
      });
    }

    const wsLink = new WebSocketLink({
      uri: `wss://${END_POINT}`,
      options: {
        lazy: true,      // არ სცადოს კავშირი სანამ subscription არ არის
        reconnect: true, // reconnect მხოლოდ საჭიროებისას
        connectionParams: () => ({
          authToken: token,
        }),
      },
    });

    const link = split(
      ({ query }) => {
        const definition = getMainDefinition(query);
        return (
          definition.kind === "OperationDefinition" &&
          definition.operation === "subscription"
        );
      },
      wsLink,
      uploadLink
    );

    return new ApolloClient({
      link,
      cache: new InMemoryCache(),
    });
  }, [token]);

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default ApolloProviderWrapper;